import { useState } from "react";
import ImageInput from "../ui/InputImage";
import NoteEditor from "./NoteEditor";

export default function CreateQuestion({
  handleCreateQuestion,
  newNoteText,
  setNewNoteText,
  newFiles,
  setNewFiles,
  setMode,
}) {
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isBulkMode && newFiles && newFiles.length > 0) {
        await handleCreateQuestion(e, newFiles, true);
      } else {
        await handleCreateQuestion(e, null, false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page">
      <h2>{isBulkMode ? "Bulk Upload Questions" : "Create Question"}</h2>

      <div className="toggle-container">
        <span className="toggle-label">Bulk Mode (One Question per Image)</span>
        <label className="switch">
          <input
            type="checkbox"
            checked={isBulkMode}
            onChange={(e) => setIsBulkMode(e.target.checked)}
            disabled={loading}
          />
          <span className="slider"></span>
        </label>
      </div>

      <form onSubmit={handleSubmit}>
        {!isBulkMode && (
          <>
            <label style={{ fontWeight: "bold" }}>Note</label>
            <NoteEditor
              value={newNoteText}
              onChange={setNewNoteText}
              placeholder="Enter question details (Markdown & Math supported)..."
              disabled={loading}
            />
          </>
        )}

        <div style={{ marginTop: isBulkMode ? 0 : 15, marginBottom: 15 }}>
          {/* Files are sorted/reordered inside this component */}
          <ImageInput
            files={newFiles}
            setFiles={setNewFiles}
            disabled={loading}
          />

          {isBulkMode && newFiles?.length > 0 && (
            <p
              style={{
                fontSize: "0.85rem",
                color: "var(--text-secondary)",
                marginTop: 8,
              }}
            >
              Will create <strong>{newFiles.length}</strong> separate questions
              in the order shown above.
            </p>
          )}
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading
              ? "Creating..."
              : isBulkMode
              ? "Create All Questions"
              : "Add Question"}
          </button>
          <button
            type="button"
            className="btn-outline-secondary"
            onClick={() => setMode("view")}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
